import { defineStore } from "pinia";
import { computed, ref } from "vue";
import ApiSegments from "@/apis/ApiSegments";
import ApiApps from "@/apis/ApiApps";
import { useLegacyTmpStore } from "./legacyTmpStore";
import { catchable, exceptionWrapper } from "./piniaUtils";

export const useAllSegmentsStore = defineStore("all-segments", () => {
  const legacyTmpStore = useLegacyTmpStore();
  const segments = ref([]);
  const getSegmentsLoading = ref(false);

  const sortedAllSegments = computed(() => {
    return [...segments.value].sort((a, b) =>
      a.name.toLowerCase() > b.name.toLowerCase()
        ? 1
        : b.name.toLowerCase() > a.name.toLowerCase()
          ? -1
          : 0,
    );
  });

  const getSegments = ({ appId, params }, { nonBlocking } = { nonBlocking: false }) => {
    const fn = async () => {
      if (params?.metric_periods) {
        const [segmentsValue] = await Promise.all([
          ApiSegments.getSegments(appId, params),
          ApiApps.getCustomMetricsStatus(appId, { data_type: "segments", ...params }),
        ]);

        segments.value = segmentsValue;
        legacyTmpStore.getSegmentModel(appId);
      } else {
        segments.value = await ApiSegments.getSegments(appId, params);
      }
    };
    return nonBlocking
      ? exceptionWrapper(fn, { loading: getSegmentsLoading })
      : catchable({ t: fn, loadable: true });
  };

  return { segments, getSegments, sortedAllSegments, getSegmentsLoading };
});
